/* eslint-disable */

import * as ApolloReactComponents from '@apollo/client/react/components';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';
import {
    ProductContestFragment,
    ProductFixedPriceProjectFragment,
    ProductQuotedProjectFragment,
} from '../../graphql/Products.generated';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type WebOnboarderProductsQueryVariables = Types.Exact<{
    input: Types.ProductsInput;
}>;

export type WebOnboarderProductsQuery = {
    __typename: 'Query';
    products: Array<
        | ({ __typename: 'ProductFixedPriceProject' } & ProductFixedPriceProjectFragment)
        | ({ __typename: 'ProductContest' } & ProductContestFragment)
        | ({ __typename: 'ProductQuotedProject' } & ProductQuotedProjectFragment)
    >;
};

export const WebOnboarderProductsDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'WebOnboarderProducts' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductsInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'products' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'ProductFixedPriceProject' },
                                },
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'ProductContest' },
                                },
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'ProductQuotedProject' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ProductFixedPriceProject' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductFixedPriceProject' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'details' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageDetails' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'additionalDetails' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'PackageDetails' },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'disclaimer' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pricing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'FixedPrice' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'key' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'PackageDetails' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductPackageDetails' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'ctaLink' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'FixedPrice' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FixedPrice' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'gst' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'earningsInUsd' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amounts' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'amountInCents' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'amountInCents' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ProductContest' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductContest' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'contestDetails' },
                        name: { kind: 'Name', value: 'details' },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pricing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'FixedPrice' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'key' } }],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ProductQuotedProject' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProductQuotedProject' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'quotedProjectDetails' },
                        name: { kind: 'Name', value: 'details' },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceRange' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'fromPrice' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketing' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'key' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export type WebOnboarderProductsComponentProps = Omit<
    ApolloReactComponents.QueryComponentOptions<
        WebOnboarderProductsQuery,
        WebOnboarderProductsQueryVariables
    >,
    'query'
> &
    ({ variables: WebOnboarderProductsQueryVariables; skip?: boolean } | { skip: boolean });

export const WebOnboarderProductsComponent = (props: WebOnboarderProductsComponentProps) => (
    <ApolloReactComponents.Query<WebOnboarderProductsQuery, WebOnboarderProductsQueryVariables>
        query={WebOnboarderProductsDocument}
        {...props}
    />
);

/**
 * __useWebOnboarderProductsQuery__
 *
 * To run a query within a React component, call `useWebOnboarderProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebOnboarderProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebOnboarderProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebOnboarderProductsQuery(
    baseOptions: Apollo.QueryHookOptions<
        WebOnboarderProductsQuery,
        WebOnboarderProductsQueryVariables
    >
) {
    return Apollo.useQuery<WebOnboarderProductsQuery, WebOnboarderProductsQueryVariables>(
        WebOnboarderProductsDocument,
        baseOptions
    );
}
export function useWebOnboarderProductsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        WebOnboarderProductsQuery,
        WebOnboarderProductsQueryVariables
    >
) {
    return Apollo.useLazyQuery<WebOnboarderProductsQuery, WebOnboarderProductsQueryVariables>(
        WebOnboarderProductsDocument,
        baseOptions
    );
}
export type WebOnboarderProductsQueryHookResult = ReturnType<typeof useWebOnboarderProductsQuery>;
export type WebOnboarderProductsLazyQueryHookResult = ReturnType<
    typeof useWebOnboarderProductsLazyQuery
>;
export type WebOnboarderProductsQueryResult = Apollo.QueryResult<
    WebOnboarderProductsQuery,
    WebOnboarderProductsQueryVariables
>;
